import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import themes from "~/themes";
import { Container123 } from "./elements";

function NavLinkbar() {
  const history = useHistory();

  return (
    <Container123>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "0.3rem",
        }}
      >
        <img
          onClick={() => history.push("/")}
          src={themes.components.images.logoHorizontalTeuCard}
          alt="Logo da empresa"
        />
        <span>Versão: {process.env.REACT_APP_VERSAO_APP}</span>
      </div>
    </Container123>
  );
}

export default NavLinkbar;
